import { SupportContextProps, SupportProvider } from '@jbhi-fi/components/src/context/SupportProvider';
import React, { ReactNode } from 'react';
import { submitTracking } from '@jbhi-fi/components/src/Tracking/utils/shopifyActionTrackingHelper';
import { dataLayerPushEvent } from '../templates/components/pdp/utils/utils';
import {
  getZendeskTriggerElement,
  setZendeskChatDepartment,
  zendeskHasLoaded,
  zendeskTriggerIsReady,
  zendeskTriggerAction,
  zendeskChatHasLoaded,
} from '@jbhi-fi/utils/src/zendesk/zendesk';

const shopifyValues = (isInstallationOffer?: boolean): SupportContextProps => ({
  phoneNumber: window.Jbhifi.jbSalesLine || '',
  onChatClick: async () => {
    if (window?.Jbhifi?.storeLocation === 'NZ') {
      return window.openChatButtonClick();
    }

    const chatTriggerElement = getZendeskTriggerElement();
    const department = isInstallationOffer ? 'Installations' : undefined;

    if (window.Jbhifi?.zendeskEnabled && !zendeskTriggerIsReady(chatTriggerElement)) return;
    if (window.Jbhifi?.zendeskEnabled && !zendeskHasLoaded()) {
      await zendeskTriggerAction(chatTriggerElement, department);
    } else {
      await setZendeskChatDepartment(department);
    }

    if (zendeskChatHasLoaded()) window.$zopim?.livechat.window.show();

    const isCompare = window.location.pathname.includes('/pages/compare');
    if (isCompare) {
      submitTracking({
        event: 'productCompare',
        action: 'chat',
        trackingDescriptor: {
          page: 'comparePage',
        },
        gtm: {},
      });
    } else {
      dataLayerPushEvent('pdp-seenitcheaper-chat', window.gtm.product);
    }
  },
  onCallClick: () => {
    const isCompare = window.location.pathname.includes('/pages/compare');
    if (!isCompare) {
      dataLayerPushEvent('pdp-seenitcheaper-call', window.gtm.product);
    }
    window.location.href = `tel:${window.Jbhifi.jbSalesLine}`;
  },
});

export const ShopifySupportProvider = ({
  children,
  isInstallationOffer = false,
}: {
  children: ReactNode;
  isInstallationOffer?: boolean;
}) => {
  return <SupportProvider {...shopifyValues(isInstallationOffer)}>{children}</SupportProvider>;
};
